import { createHashHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createLogger } from 'redux-logger';
import { Dispatch, SetStateAction } from 'react';
import { RootReducer, State } from './root.reducer';
import { RootSaga } from './root.saga';
import { Config } from '../config/config';

export type StateType<T> = [T, Dispatch<SetStateAction<T>>]

// history;
export const history = (() => {
  const hash = window.location.href.split('/')[3];
  if (Config.mode !== 'local') {
    if (hash === undefined || hash === '') {
      window.location.href = 'https://service.reformcloud.com/';
    }
  }
  return createHashHistory();
})();
// export const history = createHashHistory();

// redux-saga
const sagaMiddleWare = createSagaMiddleware();

// redux-persist
// const persistedReducer = persistReducer({
//   key: 'root',
//   whitelist: [],
//   blacklist: ['user'],
//   storage,
//   // transforms: [
//   //   encryptTransform({ secretKey: 'my-super-secret-key' }),
//   // ],
//   debug: true,
// }, RootReducer(history));

// redux-logger
const reduxLogger = createLogger({
  collapsed: true,
  diff: true,
  duration: true,
});

// redux-loggerの切り替え
const isLogger = false;

// ストア生成
export const ConfigureStore = (preloadState?: State) => {
  // const middleware = [sagaMiddleWare, routerMiddleware(history)];
  const middleware = isLogger
    ? [reduxLogger, sagaMiddleWare, routerMiddleware(history)]
    : [sagaMiddleWare, routerMiddleware(history)];
  const middlewareEnhancer = applyMiddleware(...middleware);
  const store = createStore(
    RootReducer(history),
    preloadState as any,
    middlewareEnhancer,
  );
  const persist = persistStore(store);
  sagaMiddleWare.run(RootSaga);
  return { store, persist };
};

const obj = ConfigureStore();
export const Store = obj.store;
export const Persist = obj.persist;
